// https://stackoverflow.com/a/37511463
/**
 * éàîùïç => eaiuic
 */
export const normalize = (str: string) => str.normalize('NFD').replace(/\p{Diacritic}/gu, '')

// cf https://stackoverflow.com/questions/1981349/regex-to-replace-multiple-spaces-with-a-single-space
export const removeExtraSpaces = (str: string) => str.trim().replace(/\s\s+/g, ' ')
